define('windowsToolsView',[
  'module',
  'marionette',
  'underscore',
  'windows',
  'template!windowsToolsView'
], function (
  Module,
  Marionette,
  _,
  Windows,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'windows-tools-view', 
    
    ui: {
      divideScreenButton: '.divide-screen-button',
      managmentButton: '.managment-button',
      minimizeAllButton: '.minimize-all-button'
    },

    events: {
      'click @ui.managmentButton': 'onManagmentButtonClick',
      'click @ui.minimizeAllButton': 'onMinimizeAllButtonClick',
      'click @ui.divideScreenButton': 'onDivideScreenButtonClick'
    },

    initialize: function () {    
      Windows.toolsView = this; 
      this.divideScreen = false;
    },

    onRender: function () {
      if(Windows.views.length === 0) {        
        this.ui.managmentButton.attr('data-status', 'empty');
        this.ui.minimizeAllButton.attr('data-status', 'empty');
      }          
      else {
        if(Windows.managmentView.isOpened())
          this.ui.managmentButton.attr('data-status', 'opened');
        else  
          this.ui.managmentButton.attr('data-status', 'closed');

        //-----------              
        Windows.views.forEach(_.bind(function (view) {
          if(!view.isMinimized())
            this.ui.minimizeAllButton.attr('data-status', 'enabled');
        }, this));
      } 

      //-----------    
      var visibleViewCount = 0;
      Windows.views.forEach(_.bind(function (view) {
        if(!view.isMinimized())
          visibleViewCount++;
      }, this));
      
      if(!this.divideScreen) {
        if(visibleViewCount > 1)
          this.ui.divideScreenButton.attr('data-status', 'not-empty');
        else
          this.ui.divideScreenButton.attr('data-status', 'empty');        
      } else
        this.ui.divideScreenButton.attr('data-status', 'activated');      
    },

    onManagmentButtonClick: function () {
      if(Windows.managmentView.isOpened())
        Windows.managmentView.hide();
      else
        Windows.managmentView.show();
    },

    onMinimizeAllButtonClick: function () {
      Windows.views.forEach(function (view) {
        if(!view.isMinimized())
          view.minimize();
      });
    },

    onDivideScreenButtonClick: function () {
      this.divideScreen = !this.divideScreen;
      this.setDevideScreen();     
    },

    setDevideScreen: function () {     
      if(this.divideScreen) {
        var visibleViews = [];
        Windows.views.forEach(_.bind(function (view) {
          if(!view.isMinimized())
            visibleViews.push(view);
        }, this));

        if (visibleViews.length <= 1) 
          this.divideScreen = false;
      }

      this.render();
      Windows.divideScreen();
    }
  });
});
